import { PlatformType } from "./Platform";

/**
 * Read model for the post_analytics collection — one document per
 * (WaveGen post × platform connection), written exclusively by the server.
 * PostViewer subscribes with:
 *   where userId == activeWorkspaceId && wavegenPostId == postId
 * Keep in sync with server/src/models/PostAnalytics.ts.
 */

export const POST_ANALYTICS_COLLECTION = "post_analytics";

export interface NormalizedMetrics {
  impressions?: number | null;
  reach?: number | null;
  videoViews?: number | null;
  likes?: number | null;
  reactions?: number | null;
  comments?: number | null;
  shares?: number | null;
  saves?: number | null;
  contentClicks?: number | null;
  outboundClicks?: number | null;
  watchTimeTotalSec?: number | null;
  watchTimeAverageSec?: number | null;
}

export type MetricName = keyof NormalizedMetrics;

export type SyncStateName =
  | "scheduled"
  | "retrying"
  | "reconnect_required"
  | "scope_missing"
  | "deleted_on_platform"
  | "complete";

export interface LatestObservation {
  observedAt: number;
  schemaVersion: number;
  adapterVersion: number;
  supportedMetrics: MetricName[];
  metrics: NormalizedMetrics;
}

export interface PostAnalytics {
  id: string; // `${wavegenPostId}_${connectionId}`
  /** Explicit tenant key on workspace-aware records; absent on legacy rows. */
  workspaceId?: string;
  /** Compatibility tenant alias. Its value is the workspace id. */
  userId: string;
  wavegenPostId: string;
  connectionId: string;
  stableAccountId: string;
  platform: PlatformType;
  platformPostId: string;
  publishedAt: number;
  latest?: LatestObservation;
  sync: {
    state: SyncStateName;
    nextPollAt: number | null;
    lastAttemptAt?: number | null;
    // scope_missing only: "reconnect" when reconnecting the account would
    // grant the missing analytics scope (server requests it post env-flip).
    remedy?: "reconnect" | null;
  };
}
